import {Actions, createEffect, ofType} from '@ngrx/effects';
import {tap} from 'rxjs';
import {Injectable} from '@angular/core';
import {LoadingIndicatorService} from '../services/loading-indicator.service';

@Injectable()
export class RouterEffects {
  navigation$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType('@ngrx/router-store/navigation'),
        tap(() => {
          this.loadingIndicatorService.displayLoadingIndicator();
        })
      ),
    {dispatch: false}
  );

  navigated$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType('@ngrx/router-store/navigated'),
        tap(() => {
          this.loadingIndicatorService.hideLoadingIndicator();
        })
      ),
    {dispatch: false}
  );

  constructor(
    private actions$: Actions,
    private loadingIndicatorService: LoadingIndicatorService
  ) {}
}
